module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3 box"
  }, _vm._l((_vm.logs), function(log) {
    return _c('div', {
      key: log.id,
      staticClass: "log"
    }, [_vm._v("\n        " + _vm._s(log.message) + "\n    ")])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f42f63a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/twillo/Logs.vue
// module id = 704
// module chunks = 1